//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionTiny, IconCross, Typography } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

import { FACET_PAGE, FACET_QUERY, FACET_SORT } from '../../../utils/algolia'
import FacetsFilters from '../Facets'
import PriceFilter from '../PriceFilter'

import translations from './Refinements.translations'
import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './constants'

export default {
  components: {
    FacetsFilters,
    PriceFilter,
    Typography,
    ActionTiny,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    IconCross: () => IconCross,
    translations: () => translations,
    ...mapGetters({
      minPrice: 'landingSearch/minPrice',
      maxPrice: 'landingSearch/maxPrice',
      facets: 'landingSearch/facets',
      searchNbResults: 'landingSearch/nbResults',
    }),
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
    isPriceRange() {
      return this.minPrice !== this.maxPrice
    },
    showResetButton() {
      return Object.keys(this.filters).some(
        (key) => ![FACET_PAGE, FACET_SORT, FACET_QUERY].includes(key),
      )
    },
  },
  methods: {
    onResetFilters() {
      this.$emit('reset-filters')
    },
    handleFacetFilter(facetGroup, value) {
      if (value) {
        trackClick({
          name: facetGroup.facet_name,
          zone: 'product list > side filter',
          value,
        })
      }

      this.$emit('change', { [facetGroup.facet_name]: value })
    },
  },
}
